import { useRef } from "react";
import { useState } from "react";

// const MAX_COUNT = 5;

const AddAttestationService = () => {
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [fileLimit, setFileLimit] = useState(false);
  const [filename, setFileName] = useState();

  const inputRef = useRef(null);
  const handleClick = () => {
    // 👇️ open file input box on click of other element
    inputRef.current.click();
  };

  const handleUploadFiles = (files) => {
    const uploaded = [...uploadedFiles];
    let limitExceeded = false;
    files.some((file) => {
      if (uploaded.findIndex((f) => f.name === file.name) === -1) {
        uploaded.push(file);
      }
    });
    if (!limitExceeded) setUploadedFiles(uploaded);
  };
  const handleFileEvent = (e) => {
    const chosenFiles = Array.prototype.slice.call(e.target.files);
    handleUploadFiles(chosenFiles);

    const fileObj = e.target.files && e.target.files[0];
    if (!fileObj) {
      return;
    }
    e.target.value = null;
    setFileName({
      ...filename,
      name: fileObj.name,
      size: fileObj.size,
      type: fileObj.type,
    });
  };

  return (
    <>
      <div className="outer-wrapper my-[3rem]">
        <div className="inner-wrapper sm:flex block flex-col justify-center items-center mt-[1rem]  ">
          <div className="flex flex-col gap-3 p-8 px- shadow-card text-sm md:w-[53rem] sm:w-[40rem] w-[auto]  rounded-md transition-all duration-500">
            <div className="flex justify-between">
              <h2 className="font-bold text-[1.1rem] leading-5">
                Add Attestetion Services
              </h2>
            </div>

            <div className="sm:flex grid gap-4">
              <div
                className="MuiFormControl-root flex-1"
                inputprops="[object Object]"
                inputlabelprops="[object Object]"
              >
                <div className="relative">
                  <select
                    id="floating_outline"
                    className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                    placeholder=" "
                  >
                    <option>
                      Institution<span className="text-[#F21E26]">*</span>
                    </option>
                    <option>1</option>
                    <option>2</option>
                    <option>3</option>
                  </select>
                  <label
                    for="floating_outlined"
                    className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                  >
                    Institution <span className="text-[#F21E26]">*</span>
                  </label>
                </div>
              </div>
              <div className="MuiFormControl-root MuiTextField-root flex-1">
                <div className="relative w-[24rem]">
                  <input
                    type="text"
                    id="floating_outlined"
                    className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                    placeholder=" "
                  />
                  <label
                    for="floating_outlined"
                    className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                  >
                    Documents Name *
                  </label>
                </div>
              </div>
            </div>

            <div className="sm:flex grid gap-4">
              <div className="MuiFormControl-root MuiTextField-root flex-1">
                <div className="relative w-[24rem]">
                  <input
                    type="text"
                    id="floating_outlined"
                    className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                    placeholder=" "
                  />
                  <label
                    for="floating_outlined"
                    className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                  >
                    Type
                  </label>
                </div>
              </div>
              <div
                className="MuiFormControl-root flex-1"
                inputprops="[object Object]"
                inputlabelprops="[object Object]"
              >
                <div className="relative">
                  <select
                    id="floating_outline"
                    className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                    placeholder=" "
                  >
                    <option>Country</option>
                    <option>1</option>
                    <option>2</option>
                    <option>3</option>
                  </select>
                  <label
                    for="floating_outlined"
                    className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                  >
                    Quantity
                  </label>
                </div>
              </div>
            </div>
            <div
              className="MuiFormControl-root flex-1"
              inputprops="[object Object]"
              inputlabelprops="[object Object]"
            >
              <div className="border-dashed ">
                {/* <div className="MuiFormControl-root MuiTextField-root flex-1"> */}
                <div className="relative w-[49rem] text-black border-dashed border-2 bg-[#efefef]">
                  <div className="flex justify-between p-1">
                    <p className="text-[#9E9E9E] font-medium">Upload File</p>
                    <p className="text-[#9E9E9E]">
                      Documents should be in {/* <a href="#"> */}
                      <b>pdf</b>
                      {/* </a>{" "} */}
                      form
                    </p>
                  </div>
                  <input
                    id="fileUpload"
                    type="file"
                    multiple
                    style={{ display: "none" }}
                    accept="application/pdf, image/png"
                    onChange={handleFileEvent}
                    disabled={fileLimit}
                    ref={inputRef}
                  />
                  <button
                    onClick={handleClick}
                    className="file-btn flex w-[49rem] justify-center"
                  >
                    <img
                      src="/nrp-icons/booking-icon/upload-file-icon.svg"
                      alt=""
                      className="h-10"
                    />
                  </button>
                  <p className="text-center pt-2 pb-2 text-[#9E9E9E] font-bold">
                    Drag and drop or brows files to upload!
                  </p>
                </div>
                {/* </div> */}
              </div>
            </div>
            <div className="flex ">
              {uploadedFiles.map((file) => (
                <div className="flex bg-[#efefef] p-2 w-[14rem] mr-2">
                  <img
                    src="/nrp-icons/booking-icon/image-icon.svg"
                    alt=""
                    className="w-[2rem] h-5"
                  />
                  <p>{file.name} </p>
                  <img
                    src="/nrp-icons/booking-icon/delete.svg"
                    alt=""
                    className="w-[2rem] h-5 "
                  />
                </div>
              ))}
            </div>
            {/* <div className='flex justify-between bg-[#efefef] p-2 w-[14rem]'>
         
        <img src='/nrp-icons/booking-icon/image-icon.svg'alt='' className='w-[2rem] h-5'/>
        <p>{filename.name}</p>
        <img src='/nrp-icons/booking-icon/delete.svg' alt='' className='w-[2rem] h-5 '/>
          
            
      </div> */}

            {/* div ref={refs[2]} className="flex flex-col gap-3 p-8 px- shadow-card text-sm md:w-[53rem] sm:w-[40rem] w-[auto]  rounded-md transition-all duration-500"> */}

            <button className="text-white bg-[#D40511] h-[2.5rem] border border-[#F21E26] w-[100%] sm:w-[49rem]  rounded-md  p-1 text-sm hover:bg-[#F21E26] hover:text-white transition-all duration-500">
              Next
            </button>
          </div>
        </div>

        {/* DOCUMENT LIST */}
        <div className="outer-wrapper my-[3rem]">
          <div className="inner-wrapper sm:flex block flex-col justify-center items-center mt-[1rem]  ">
            <div className="flex flex-col gap-3 p-8 px- shadow-card text-sm md:w-[53rem] sm:w-[40rem] w-[auto]  mx-[1rem] rounded-md transition-all duration-500">
              <div className="flex justify-between">
                <h2 className="font-bold text-[1.1rem] leading-5">
                  Documents List
                </h2>
              </div>

              <div className="flex gap-4">
                <div className="flex-1 flex flex-col">
                  <table className="mt-6">
                    <thead>
                      <tr className="text-left bg-gray-100">
                        <th className="border p-2">S.No</th>
                        <th className="border p-2">Document Name</th>
                        <th className="border p-2">Category</th>
                        <th className="border p-2">Type</th>
                        <th className="border p-2">Quantity</th>
                        <th className="border p-2">Attachments</th>
                        <th className="border p-2">Charges</th>
                        <th className="border p-2"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="border p-2">1</td>
                        <td className="border p-2">Document 1</td>
                        <td className="border p-2">HEC</td>
                        <td className="border p-2">Copy</td>
                        <td className="border p-2">4</td>
                        <td className="border p-2">
                          <span className="flex justify-around">
                            4
                            <img
                              src="./nrp-icons/booking-icon/attachments.svg"
                              alt=""
                              className="h-[1.5\] w-[1rem]"
                            />
                          </span>
                        </td>
                        <td className="border p-2">1000</td>
                        <td className="border p-2">
                          <span className="flex justify-around">
                            <img
                              src="./nrp-icons/booking-icon/edit.svg"
                              alt=""
                              className="h-[1] w-[1rem]"
                            />
                            <img
                              src="./nrp-icons/booking-icon/delete.svg"
                              alt=""
                              className="h-[1rem ] w-[.9rem]"
                            />
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td className="border p-2">2</td>
                        <td className="border p-2">Document 2</td>
                        <td className="border p-2">MOFA</td>
                        <td className="border p-2">Original</td>
                        <td className="border p-2">1</td>
                        <td className="border p-2">
                          <span className="flex justify-around">
                            1
                            <img
                              src="./nrp-icons/booking-icon/attachments.svg"
                              alt=""
                              className="h-[1.5] w-[1rem]"
                            />
                          </span>
                        </td>
                        <td className="border p-2">2500</td>
                        <td className="border p-2">
                          <span className="flex justify-around">
                            <img
                              src="./nrp-icons/booking-icon/edit.svg"
                              alt=""
                              className="h-[1] w-[1rem]"
                            />
                            <img
                              src="./nrp-icons/booking-icon/delete.svg"
                              alt=""
                              className="h-[1rem ] w-[.9rem]"
                            />
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td className="border p-1">3</td>
                        <td className="border p-2">Document 3</td>
                        <td className="border p-2">HEC</td>
                        <td className="border p-2">Original</td>
                        <td className="border p-2">2</td>
                        <td className="border p-2 ">
                          <span className="flex justify-around">
                            2
                            <img
                              src="./nrp-icons/booking-icon/attachments.svg"
                              alt=""
                              className="h-[1.5] w-[1rem]"
                            />
                          </span>
                        </td>
                        <td className="border p-2">1300</td>
                        <td className="border p-2 ">
                          <span className="flex justify-around">
                            <img
                              src="./nrp-icons/booking-icon/edit.svg"
                              alt=""
                              className="h-[1] w-[1rem]"
                            />
                            <img
                              src="./nrp-icons/booking-icon/delete.svg"
                              alt=""
                              className="h-[1rem ] w-[.9rem]"
                            />
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="sm:flex grid gap-4 ">
                <div className="MuiFormControl-root MuiTextField-root flex-1">
                  <button className="text-[#F21E26]  h-[2.5rem] border border-[#F21E26] w-[100%] sm:w-[24rem]  rounded-md  p-1 text-sm hover:bg-[#F21E26] hover:text-white transition-all duration-500">
                    Previous
                  </button>
                  <button className="text-white bg-[#D40511] h-[2.5rem] border border-[#F21E26] w-[100%] sm:w-[24rem] ml-[1rem]  rounded-md  p-1 text-sm hover:bg-[#F21E26] hover:text-white transition-all duration-500">
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default AddAttestationService;
